// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__ZDp+y"};